import { render, staticRenderFns } from "./PortalFeatureForm.vue?vue&type=template&id=4514658d&scoped=true&lang=html&"
import script from "./PortalFeatureForm.vue?vue&type=script&lang=js&"
export * from "./PortalFeatureForm.vue?vue&type=script&lang=js&"
import style0 from "./PortalFeatureForm.vue?vue&type=style&index=0&id=4514658d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4514658d",
  null
  
)

export default component.exports